import get from 'lodash/get';
import 'modules/lazyload-image';
import 'styleguide/modules/slick-carousel';
import 'modules/input-suggestion';
import {getLCP, getCLS, onINP} from 'web-vitals';
import shopTheLook from 'modules/shop-the-look';
import './directives';
import 'modules/state-search';

const updateClsCookieObject = (key, prop) => {
  try {
      let banner = JSON.parse(getCookie('cls') || "{}");
      banner[key] = prop;
      setCookie('cls', JSON.stringify(banner), 2);
  } catch(error) {
      console.log(error);
  }
};

const addToGlobal = (...propTuple) => {
  propTuple.forEach(([name, value]) => {
    window[name] = value;
  });
};

addToGlobal(
  ['getLCP', getLCP],
  ['getCLS', getCLS],
  ['onINP', onINP],
  ['updateClsCookieObject', updateClsCookieObject]
);



$(document).ready(() => {
  $('.typeahead_il').inputSuggestion();
  $('.typeahead_kw').inputSuggestion();
  initSideNavigation();
  shopTheLook();
  $('.js-state-search').stateSearch();
});

function initSideNavigation(){
  if($('#richnav-wrapper').length) {
    $.ajax({
      type: "GET",
      url: '/r/mobile/sidebarNav.jsp?refURL=' + window.rcProps.loginURL,
      success: function (html) {
        $('#richnav-wrapper').empty().append(html);
        $('#js-rich-nav').richNav();
        $('.js-accordion').accordion();
        $('.js-switch-class').switchClass();
      }
    });
  }
}

/**
 *
 * @param url
 * @param module
 * @param action
 * @param params - appends key-value pairs to URL as query parameters for tracking purposes.
 * @returns {string}
 */
window.logEngagement = function logEngagement(url, module, action, params){
  if (params) {
    url += ((url.indexOf('?') >= 0) ? '&' : '?') + $.param(params);
  }
  $.ajax({
    type: 'POST',
    data: $.param({
      url: url,
      module: module,
      action: action
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
}

/**
 * Logs engagement to engagement_tracking with details column data
 * @param url - string
 * @param module - string
 * @param action - string
 * @param details - string
 */
window.logEngagementWithDetails = function logEngagementWithDetails(url, module, action, details) {
  $.ajax({
    type: 'POST',
    data: $.param({
      url: url,
      module: module,
      action: action,
      details: details
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
}

/**
 * Logs engagement to engagement_tracking with details column data
 * @param url - string
 * @param module - string
 * @param action - string
 * @param details - string
 * @param params - appends key-value pairs to URL as query parameters for tracking purposes.
 */
window.logEngagementWithDetailsAndParams = function logEngagementWithDetailsAndParams(url, module, action, details, params) {
  if (params) {
    url += ((url.indexOf('?') >= 0) ? '&' : '?') + $.param(params);
  }
  $.ajax({
    type: 'POST',
    data: $.param({
      url: url,
      module: module,
      action: action,
      details: details
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
}

// Global Lodash
window.lodash = {
  get
};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/global.js